<template>
    <div>
        <!-- 功能按钮 -->
        <buttonlist @help="help" @opentable="opentable" @add="add" @search="search" @reflash="reflash" @exps="exp" @del="delall" @save="save"
                    ref="SetBtn"></buttonlist>
        <!-- 功能按钮 -->
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <el-tabs v-model="activeName" @tab-click="selectInfo">
                    <el-tab-pane :label="$t('getapi[11]')" name="0">
                        <wTable
                                id="xpane-0"
                                :data="datajson"
                                :loading="loading"
                                queryData="SalCustomerInfoViewInfo"
                                :filter_language="['Customer_Important','Status_Name','direct_move_flag','Issue_Part_Flow','Sale_Issue_Type']"
                                :filter_thousandth="['CheckOut_Cycle','Delivery_Leadtime']"
                                :header="tableHeader"
                                :option="tableOption"
                                @handleSelectionChange="handleSelectionChange"
                                @edits="edits"
                                @rowdblclick="openEdit"
                                ref="singleTable"
                        ></wTable>
                        <!-- 表格 -->
                        <!--<el-table
                                :data="datajson"
                                v-loading="loading"
                                ref="singleTable"
                                @current-change="handleCurrentChanges"
                                :highlight-current-row="true"
                                @row-click="edits"
                                @row-dblclick="openEdit"
                                show-overflow-tooltip="true"
                                border
                                stripe
                                size="mini"
                                header-row-class-name="headerclass"
                                :height="tableHeight - reduceTableHeight"
                                tab-click="selectInfo(0)"
                                @selection-change="handleSelectionChange"
                                style="width: 100%; margin-top: 0px"
                        >
                            <el-table-column type="selection"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Exclusively_Id" label="ID"
                                             v-if="false"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Customer_ID" :label="$t('getapi[2583]')"
                                             width="100">
                                <template scope="scope">
                                    <input
                                            type="text"
                                            class="fsd clerinput"
                                            @keydown="shows($event, scope.$index)"
                                            @keyup="show($event, scope)"
                                            v-model="scope.row.Customer_ID"
                                            readonly
                                    />
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Customer_Name" :label="$t('getapi[2584]')"
                                             width="200"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="ShortName" :label="$t('getapi[2077]')"
                                             width="80"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Customer_Type_Name" :label="$t('getapi[1114]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Customer_Group_Name"
                                             :label="$t('getapi[1115]')" width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Customer_Important" :label="$t('getapi[2585]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Customer_Developer" :label="$t('getapi[2586]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Country" :label="$t('getapi[2587]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="District" :label="$t('getapi[2588]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Customer_Address" :label="$t('getapi[2589]')"
                                             width="200"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="LegalPerson" :label="$t('getapi[1242]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Contact_Telephone" :label="$t('getapi[1202]')"
                                             align="right" width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Fax" :label="$t('getapi[1203]')" width="100"
                                             align="right"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Contact_Person" :label="$t('getapi[1204]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Contact_Post" :label="$t('getapi[1205]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Post_Code" :label="$t('getapi[1206]')"
                                             width="100" align="right"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Mail_Address" :label="$t('getapi[1207]')"
                                             width="100" align="right"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Phase_in_Date" :label="$t('getapi[548]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Phase_Out_Date" :label="$t('getapi[549]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Status_Name" :label="$t('getapi[552]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="ARemarks" :label="$t('getapi[143]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="create_person" :label="$t('getapi[1311]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Create_time" :label="$t('getapi[135]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="update_time" :label="$t('getapi[1210]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="update_person" :label="$t('getapi[733]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="consignment_flag" :label="$t('getapi[2285]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="consignment_pos" :label="$t('getapi[2438]')"
                                             width="150"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="direct_move_flag" :label="$t('getapi[2592]')"
                                             width="150"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="moving_pos" :label="$t('getapi[2593]')"
                                             width="150"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Issue_Part_Flow" :label="$t('getapi[2284]')"
                                             width="150"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Sale_Issue_Type" :label="$t('getapi[2594]')"
                                             width="150"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Invoice_addr2" :label="$t('getapi[2589]')"
                                             width="150"></el-table-column>
                            &lt;!&ndash; <el-table-column show-overflow-tooltip :label="$t('basic.edit')" width="100">
                                <template slot-scope="scope">
                                    <el-button @click.native.prevent="edit(scope)" type="text" size="mini">{{ $t('getapi[34]') }}</el-button>
                                    <el-button @click.native.prevent="del(scope)" type="text" size="mini">{{ $t('getapi[40]') }}</el-button>
                                </template>
                            </el-table-column> &ndash;&gt;
                        </el-table>-->
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[2607]')" name="1">
                        <wTable
                                id="xpane-1"
                                :data="datajson"
                                :loading="loading"
                                queryData="SalCustomerInfoViewInfo"
                                :filter_language="['Status_Name']"
                                :header="tableHeader1"
                                :option="tableOption"
                                @handleSelectionChange="handleSelectionChange"
                                @edits="edits"
                                @rowdblclick="openEdit"
                                ref="singleTable1"
                        ></wTable>
                        <!-- 表格 -->
                        <!--<el-table
                                :data="datajson"
                                v-loading="loading"
                                ref="singleTable1"
                                @current-change="handleCurrentChanges"
                                :highlight-current-row="true"
                                @row-click="edits"
                                @row-dblclick="openEdit"
                                show-overflow-tooltip="true"
                                border
                                stripe
                                size="mini"
                                header-row-class-name="headerclass"
                                :height="tableHeight - reduceTableHeight"
                                @cell-dblclick="editInfo"
                                tab-click="selectInfo(0)"
                                @selection-change="handleSelectionChange"
                                style="width: 100%; margin-top: 0px"
                        >
                            <el-table-column type="selection"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Exclusively_Id" label="ID"
                                             v-if="false"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Customer_ID" :label="$t('getapi[2583]')"
                                             width="100">
                                <template scope="scope">
                                    <input
                                            type="text"
                                            class="fsd clerinput"
                                            @keydown="shows($event, scope.$index)"
                                            @keyup="show($event, scope)"
                                            v-model="scope.row.Customer_ID"
                                            readonly
                                    />
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Customer_Name" :label="$t('getapi[2584]')"
                                             width="140"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Status_Name"
                                             :label="$t('getapi[552]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Delivery_Term_Name"
                                             :label="$t('getapi[1116]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Delivery_Address"
                                             :label="$t('getapi[2595]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Delivery_Contract"
                                             :label="$t('getapi[2596]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Delivery_Phone"
                                             :label="$t('getapi[2597]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Transport_Type_Name"
                                             :label="$t('getapi[1217]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Delivery_Leadtime" :label="$t('getapi[1295]')"
                                             align="right"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="SAL_EmpName"
                                             :label="$t('getapi[2598]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="ARemarks"
                                             :label="$t('getapi[2599]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Invoice_addr2" :label="$t('getapi[2589]')"
                                             ></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Address_ShortName" :label="$t('getapi[7931]')"
                                             ></el-table-column>
                            &lt;!&ndash; <el-table-column show-overflow-tooltip :label="$t('basic.edit')" width="100">
                                <template slot-scope="scope">
                                    <el-button @click.native.prevent="edit(scope)" type="text" size="mini">{{ $t('getapi[34]') }}</el-button>
                                    <el-button @click.native.prevent="del(scope)" type="text" size="mini">{{ $t('getapi[40]') }}</el-button>
                                </template>
                            </el-table-column> &ndash;&gt;
                        </el-table>-->
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[1230]')" name="2">
                        <wTable
                                id="xpane-2"
                                :data="datajson"
                                :loading="loading"
                                queryData="SalCustomerInfoViewInfo"
                                :filter_language="['Status_Name','tax_discount_flag']"
                                :header="tableHeader2"
                                :option="tableOption"
                                @handleSelectionChange="handleSelectionChange"
                                @edits="edits"
                                @rowdblclick="openEdit"
                                ref="singleTable2"
                        ></wTable>
                        <!-- 表格 -->
                        <!--<el-table
                                :data="datajson"
                                v-loading="loading"
                                ref="singleTable2"
                                show-overflow-tooltip="true"
                                border
                                stripe
                                size="mini"
                                header-row-class-name="headerclass"
                                :height="tableHeight - reduceTableHeight"
                                @cell-dblclick="editInfo"
                                @row-dblclick="openEdit"
                                @current-change="handleCurrentChanges"
                                :highlight-current-row="true"
                                @row-click="edits"
                                tab-click="selectInfo(0)"
                                @selection-change="handleSelectionChange"
                                style="width: 100%; margin-top: 0px"
                        >
                            <el-table-column type="selection"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Exclusively_Id" label="ID"
                                             v-if="false"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Customer_ID" :label="$t('getapi[2583]')"
                                             width="100">
                                <template scope="scope">
                                    <input
                                            type="text"
                                            class="fsd clerinput"
                                            @keydown="shows($event, scope.$index)"
                                            @keyup="show($event, scope)"
                                            v-model="scope.row.Customer_ID"
                                            readonly
                                    />
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Customer_Name" :label="$t('getapi[2584]')"
                                             width="140"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Financing_Type" :label="$t('getapi[1226]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Status_Name" :label="$t('getapi[552]')"
                                             width="80"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="BankAccount_Name" :label="$t('getapi[1219]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="BankAccountNumber" :label="$t('getapi[1220]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="CheckOut_Cycle" :label="$t('getapi[1250]')"
                                             width="100" align="right"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="payment_day" :label="$t('getapi[2601]')"
                                             width="100" align="right"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Payment_Way_Name" :label="$t('getapi[1082]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Payment_Clause" :label="$t('getapi[1222]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Tax_ID" :label="$t('getapi[6445]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Tax_Rate" :label="$t('getapi[1249]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Tax_Rate_Name" :label="$t('getapi[1344]')"
                                             width="100" align="right"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Currency_Code_ID" :label="$t('getapi[1227]')"
                                             v-if="false" width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Invoice_Add" :label="$t('getapi[6446]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Invoice_Title" :label="$t('getapi[2603]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Invoice_Person" :label="$t('getapi[6447]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Invoice_Tel" :label="$t('getapi[1202]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Invoice_ZipCode" :label="$t('getapi[1206]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Balance_Mode" :label="$t('getapi[1228]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="tax_part_code" :label="$t('getapi[6448]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="tax_part_name" :label="$t('getapi[6449]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="tax_discount_flag" :label="$t('getapi[6450]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Invoice_addr2" :label="$t('getapi[2589]')"
                                             width="100"></el-table-column>
                            &lt;!&ndash; <el-table-column show-overflow-tooltip :label="$t('basic.edit')" width="100">
                                <template slot-scope="scope">
                                    <el-button @click.native.prevent="edit(scope)" type="text" size="mini">{{ $t('getapi[34]') }}</el-button>
                                    <el-button @click.native.prevent="del(scope)" type="text" size="mini">{{ $t('getapi[40]') }}</el-button>
                                </template>
                            </el-table-column> &ndash;&gt;
                        </el-table>-->
                    </el-tab-pane>
                </el-tabs>
                <!-- 表格 -->
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div  style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <div style="width:800px;min-width:800px">
                    <!-- 编辑弹框 -->
                    <table>
                        <tr>
                            <td style="width:50px;min-width:50px"><span>{{$t('getapi[2610]')}}</span></td>
                            <td style="width:150px;min-width:150px">
                                <el-input class="mcolor" v-model="formInline.customer_id" :placeholder="$t('getapi[2610]')"
                                          :readonly="!CanEdit" :class="{'readO':!CanEdit}" @input="cusinput"></el-input>
                            </td>
                            <td style="width:50px;min-width:50px"><span>{{$t('getapi[2584]')}}</span></td>
                            <td style="width:200px;min-width:200px">
                                <el-input class="mcolor" v-model="formInline.customer_name" :placeholder="$t('getapi[2584]')"></el-input>
                            </td>
                            <td style="width:50px;min-width:50px"><span>{{$t('getapi[2077]')}}</span></td>
                            <td style="width:100px;min-width:100px"><el-input class="mcolor" v-model="formInline.shortname" :placeholder="$t('getapi[2077]')"
                                          ></el-input></td>
                            <td style="width:50px;min-width:50px"><span>{{$t('getapi[6451]')}}</span></td>
                            <td style="width:150px;min-width:150px">
                                <el-select filterable v-model="formInline.status">
                                    <el-option :label="$t('getapi[203]')" :value="1"></el-option>
                                    <el-option :label="$t('getapi[231]')" :value="0"></el-option>
                                </el-select>
                            </td>
                        </tr>
                    </table>
                </div>
                <el-row>
                    <el-col :span="24">
                        <el-form :inline="true" :model="formInline" class="demo-form-inline" label-width="100px"
                                 label-position="left" size="small">
                            <el-tabs>
                                <el-tab-pane :label="$t('getapi[11]')">
                                    <div style="width:800px;;min-width:800px">
                                        <table>
                                            <tr>
                                                <td style="width:80px;min-width:80px"><span>{{$t('getapi[1114]')}}</span></td>
                                                <td style="width:120px;min-width:120px">
                                                    <routejump :urlNo="32">
                                                    <el-select filterable v-model="formInline.customer_type_id" class="mcolor">
                                                        <el-option
                                                                v-for="(item, index) in CustomerTypeList"
                                                                :label="item.Customer_type"
                                                                :value="item.Exclusively_Id"
                                                                :key="index"
                                                        ></el-option>
                                                    </el-select>
                                                    </routejump>
                                                </td>
                                                <td style="width:80px;min-width:80px"><span>{{$t('getapi[1115]')}}</span></td>
                                                <td style="width: 120px;min-width:120px">
                                                    <routejump :urlNo="33">
                                                    <el-select filterable v-model="formInline.customers_group" class="mcolor" >
                                                        <el-option
                                                                v-for="(items, index) in CustomerGroupList"
                                                                :label="items.Customer_Group"
                                                                :value="items.Exclusively_ID"
                                                                :key="index"
                                                        ></el-option>
                                                    </el-select>
                                                    </routejump>
                                                </td>
                                                <td style="width:80px;min-width:80px"><span>{{$t('getapi[2585]')}}</span></td>
                                                <td style="width: 120px;min-width:120px">
                                                    <el-select filterable v-model="formInline.customer_important">
                                                        <el-option
                                                                v-for="(item, index) in VenderImportant"
                                                                :label="item.Important_Level_name"
                                                                :value="item.Important_Level_name"
                                                                :key="index"
                                                        ></el-option>
                                                    </el-select>
                                                </td>
                                                <td style="width:80px;min-width:80px"><span>{{$t('getapi[2587]')}}</span></td>
                                                <td style="width: 120px;min-width:120px">
                                                    <routejump :urlNo="20">
                                                    <el-select filterable v-model="formInline.country" >
                                                        <el-option v-for="(item, index) in Country" :label="item.chineseName" :value="item.chineseName"
                                                                   :key="index"></el-option>
                                                    </el-select>
                                                    </routejump>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><span>{{$t('getapi[2588]')}}</span></td>
                                                <td>
                                                    <routejump :urlNo="21">
                                                    <el-select filterable v-model="formInline.district">
                                                        <el-option v-for="(item, index) in AreaS" :label="item.Area_Name"
                                                                   :value="item.Area_Name" :key="index"></el-option>
                                                    </el-select>
                                                    </routejump>
                                                </td>
                                                <td><span>{{$t('getapi[2586]')}}</span></td>
                                                <td><el-input
                                                              v-model="formInline.customer_developer"
                                                              :placeholder="$t('getapi[2586]')"></el-input></td>
                                                <td><span>{{ $t('getapi[2589]') }}</span></td>
                                                <td colspan="3"><el-input v-model="formInline.customer_address"
                                                              :placeholder="$t('getapi[2589]')"></el-input></td>
                                            </tr>
                                            <tr>
                                                <td><span>{{ $t('getapi[1242]') }}</span></td>
                                                <td><el-input v-model="formInline.legalperson" :placeholder="$t('getapi[1242]')"
                                                              ></el-input></td>
                                                <td><span>{{ $t('getapi[1241]') }}</span></td>
                                                <td><el-input class="mcolor" v-model="formInline.contact_person"
                                                              :placeholder="$t('getapi[1241]')"></el-input></td>
                                                <td><span>{{ $t('getapi[1202]') }}</span></td>
                                                <td><el-input class="mcolor" v-model="formInline.contact_telephone"
                                                              :placeholder="$t('getapi[1202]')"></el-input></td>
                                                <td><span>{{ $t('getapi[1203]') }}</span></td>
                                                <td><el-input v-model="formInline.fax" :placeholder="$t('getapi[1203]')"></el-input></td>
                                            </tr>
                                            <tr>
                                                <td><span>{{ $t('getapi[1207]') }}</span></td>
                                                <td> <el-input v-model="formInline.mail_address" :placeholder=" $t('getapi[1207]')"
                                                ></el-input></td>
                                                <td><span>{{ $t('getapi[135]') }}</span></td>
                                                <td><el-input v-model="formInline.create_time" :placeholder="$t('getapi[135]')" :readonly="true" class="readO"></el-input></td>
                                                <td><span>{{ $t('getapi[548]') }}</span></td>
                                                <td><el-date-picker
                                                        class="mcolor"
                                                        v-model="formInline.phase_in_date"
                                                        value-format="yyyy-MM-dd"
                                                        :placeholder="$t('getapi[548]')"
                                                        style="width:100%"
                                                ></el-date-picker></td>
                                                <td><span>{{ $t('getapi[549]') }}</span></td>
                                                <td><el-date-picker
                                                        v-model="formInline.phase_out_date"
                                                        value-format="yyyy-MM-dd"
                                                        :placeholder="$t('getapi[549]')"
                                                        style="width:100%"
                                                ></el-date-picker></td>
                                            </tr>
                                            <tr>
                                                <td><span>{{ $t('getapi[1206]') }}</span></td>
                                                <td><el-input v-model="formInline.post_code"
                                                              :placeholder="$t('getapi[1206]')"></el-input></td>
                                                <td><span>{{ $t('getapi[1205]') }}</span></td>
                                                <td><el-input v-model="formInline.contact_post"
                                                              :placeholder="$t('getapi[1205]')"></el-input></td>
                                                <td><span>{{ $t('getapi[143]') }}</span></td>
                                                <td colspan="3"><el-input v-model="formInline.aremarks" :placeholder="$t('getapi[143]')"></el-input></td>
                                            </tr>
                                            <tr>
                                                <td><span>{{ $t('getapi[7753]') }}</span></td>
                                                <td>
                                                    <el-select v-model="formInline.mode">
                                                        <el-option :label="$t('getapi[12811]')" :value=0></el-option>
                                                        <el-option :label="$t('getapi[12812]')" :value=1></el-option>
                                                    </el-select>
                                                </td>
                                                <td><span>{{ $t('getapi[12867]') }}</span></td>
                                                <td>
                                                    <el-checkbox v-model="formInline.iskpirate" :true-label=1
                                                                 :false-label=0 >
                                                        
                                                    </el-checkbox>
                                                </td>
                                                
                                                <td><span>{{$t('getapi[12945]')}}</span></td>
                                                <td>
                                                    <el-select filterable v-model="formInline.invoice_companyname">
                                                        <el-option v-for="(item, index) in invoicecompany" :label="item.name"
                                                                   :value="item.name" :key="index"></el-option>
                                                    </el-select>
                                                </td>
                                                
                                                <td><span>{{ $t('getapi[13185]') }}</span></td>
                                                <td>
                                                    <el-select v-model="formInline.report_need">
                                                        <el-option :label="$t('getapi[866]')" :value=0></el-option>
                                                        <el-option :label="$t('getapi[561]')" :value=1></el-option>
                                                    </el-select>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </el-tab-pane>
                                <el-tab-pane :label="$t('getapi[2607]')">
                                    <div class="box" style="width:710px">
                                        <table>
                                            <tr>
                                                <td><span>{{ $t('getapi[3475]') }}</span></td>
                                                <td><el-select class="mcolor" filterable
                                                               v-model="formInline.consignment_flag"
                                                               size="mini" @change="changeConsignmentFlag">
                                                    <el-option :label="$t('getapi[2314]')" :value=0></el-option>
                                                   <!-- <el-option :label="$t('getapi[1023]')" :value=1></el-option>-->
                                                </el-select></td>
                                                <td><span>{{$t('getapi[2438]')}}</span></td>
                                                <td><el-input
                                                        v-model="formInline.consignment_pos"
                                                        :placeholder="$t('getapi[2438]')"
                                                        type="text"
                                                        size="mini"
                                                ></el-input></td>
                                                <td><span>{{$t('getapi[2593]')}}</span></td>
                                                <td><el-input
                                                        v-model="formInline.moving_pos"
                                                        :placeholder="$t('getapi[2593]')"
                                                        type="text"
                                                        size="mini"
                                                ></el-input></td>
                                                <td style="width:200px">
                                                    <el-checkbox v-model="formInline.direct_move_flag" :true-label=1
                                                                 :false-label=0 style="margin-left: 10px">
                                                        {{$t('getapi[2592]')}}
                                                    </el-checkbox>
                                                    <el-checkbox
                                                            v-model="formInline.issue_part_flow"
                                                            :true-label=1
                                                            :false-label=0
                                                            style="margin-left: 10px"
                                                            :disabled="mposdis"
                                                    >
                                                        {{$t('getapi[2284]')}}
                                                    </el-checkbox>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colspan="2">
                                                    <el-checkbox v-model="formInline.sale_issue_type" :true-label=0 :false-label=1 style="margin-left: 10px">
                                                        {{$t('getapi[2613]')}}
                                                    </el-checkbox>
                                                </td>
                                                <td><span>{{ $t('getapi[7989]') }}</span></td>
                                                <td><el-select class="mcolor" filterable
                                                               v-model="formInline.price_type"
                                                               size="mini">
                                                    <el-option :label="$t('getapi[7990]')" :value=1></el-option>
                                                    <el-option :label="$t('getapi[7991]')" :value=0></el-option>
                                                </el-select></td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div>
                                        <el-divider content-position="center">{{$t('getapi[2595]')}}</el-divider>
                                    </div>
                                    <div>
                                        <el-button type="primary" size="mini" @click.native="addline">{{$t('getapi[878]')}}
                                        </el-button>
                                        <el-button type="primary" size="mini" @click.native="batchDel" :disabled="selectDataColist.length < 1">{{$t('getapi[3889]')}}
                                        </el-button>
                                    </div>
                                    <div>
                                        <el-table
                                                :data="CoList"
                                                :highlight-current-row="true"
                                                header-row-class-name="headerclass"
                                                show-overflow-tooltip="true"
                                                @selection-change="handleSelectionChangeColist"
                                                border
                                                stripe
                                                size="mini"
                                                style="width: 100%;"
                                                :row-class-name="tableRowClassName"
                                                @row-click="selectColist"
                                                ref="singleTable3">
                                            <el-table-column type="selection"></el-table-column>
                                            <el-table-column prop="Delivery_Term" :label="$t('getapi[1116]')">
                                                <template scope="scope">
                                                    <el-select class="mcolor" filterable v-model="scope.row.Delivery_Term" size="mini">
                                                        <el-option
                                                                v-for="item in DeliveryTermList"
                                                                :label="item.Delivery_Term"
                                                                :value="item.Exclusively_ID"
                                                                :key="item.Exclusively_ID"
                                                        ></el-option>
                                                    </el-select>
                                                </template>
                                            </el-table-column>
                                            <el-table-column prop="Transport_Type" :label="$t('getapi[1217]')">
                                                <template scope="scope">
                                                    <el-select class="mcolor" filterable
                                                               v-model="scope.row.Transport_Type"
                                                               size="mini">
                                                        <el-option v-for="item in TransMode" :label="item.TypeName"
                                                                   :value="item.Exclusively_Id"
                                                                   :key="item.Exclusively_Id"></el-option>
                                                    </el-select>
                                                </template>
                                            </el-table-column>
                                            <el-table-column prop="SAL_EmpName" :label="$t('getapi[2598]')">
                                                <template scope="scope">
                                                    <el-input
                                                            class="mcolor"
                                                            v-model="scope.row.SAL_EmpName"
                                                            size="mini"
                                                            readonly
                                                    >
                                                        <i class="el-icon-edit el-input__icon" slot="suffix"
                                                           @click="empnames(scope)"></i>
                                                    </el-input>
                                                </template>
                                            </el-table-column>
                                            <el-table-column prop="Delivery_Contract" :label="$t('getapi[2596]')">
                                                <template scope="scope">
                                                    <el-input v-model="scope.row.Delivery_Contract" type="text" size="mini"></el-input>
                                                </template>
                                            </el-table-column>
                                            <el-table-column prop="Delivery_Phone" :label="$t('getapi[2614]')">
                                                <template scope="scope">
                                                    <el-input v-model="scope.row.Delivery_Phone" type="text" size="mini"></el-input>
                                                </template>
                                            </el-table-column>
                                            <el-table-column prop="Delivery_Leadtime" :label="$t('getapi[1295]')" align="right">
                                                <template scope="scope">
                                                    <el-input v-model="scope.row.Delivery_Leadtime" type="text" size="mini"></el-input>
                                                </template>
                                            </el-table-column>
                                            <el-table-column prop="Delivery_Address" :label="$t('getapi[2595]')" width="300">
                                                <template scope="scope">
                                                    <el-popover width="400" trigger="click">
                                                        <el-input type="textarea" :rows="20" v-model="scope.row.Delivery_Address"></el-input>
                                                        <el-input slot="reference" :readonly="true" class="readO" :value="scope.row.Delivery_Address"></el-input>
                                                    </el-popover>
                                                </template>
                                            </el-table-column>
                                            <el-table-column prop="Address_ShortName" :label="$t('getapi[7931]')">
                                                <template scope="scope">
                                                    <el-input v-model="scope.row.Address_ShortName" type="text" size="mini"></el-input>
                                                </template>
                                            </el-table-column>
                                            <el-table-column prop="Remark" :label="$t('getapi[2615]')">
                                                <template scope="scope">
                                                    <el-input v-model="scope.row.Remark" type="text" size="mini"></el-input>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </div>
                                </el-tab-pane>
                                <el-tab-pane :label="$t('getapi[1230]')">
                                    <div style="margin-top: 3px;width:940px;min-width:940px">
                                        <!-- 编辑弹框 -->
                                        <div>
                                            <el-divider  content-position="left"><span style="font-weight:bold">{{$t('getapi[6452]')}}</span></el-divider>
                                        </div>
                                        <!-- <span style="font-weight:bold;">{{$t('getapi[6452]')}}</span> -->
                                        <table>
                                            <tr>
                                                <td style="width:80px;min-width:80px"><span>{{$t('getapi[6445]')}}</span></td>
                                                <td style="width:200px;min-width:200px">
                                                    <el-input class="mcolor" v-model="formInline.tax_id"
                                                              :placeholder="$t('getapi[6445]')" size="mini"></el-input>
                                                </td>
                                                <td style="width:80px;min-width:80px"><span>{{$t('getapi[6453]')}}</span></td>
                                                <td style="width:200px;min-width:200px">
                                                    <el-input class="mcolor"
                                                              v-model="formInline.invoice_addr2" :placeholder="$t('getapi[6453]')" size="mini"></el-input>
                                                </td>
                                                <td style="width:80px;min-width:80px"><span>{{$t('getapi[6454]')}}</span></td>
                                                <td style="width:100px;min-width:100px">
                                                    <el-input class="mcolor"
                                                              v-model="formInline.invoice_tel2" :placeholder="$t('getapi[6454]')" size="mini"
                                                    ></el-input>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><span>{{$t('getapi[6455]')}}</span></td>
                                                <td>
                                                    <el-input class="mcolor"
                                                              v-model="formInline.bankaccount_name" :placeholder="$t('getapi[6455]')"
                                                              size="mini"></el-input>
                                                </td>
                                                <td><span>{{$t('getapi[1220]')}}</span></td>
                                                <td>
                                                    <el-input class="mcolor"
                                                              v-model="formInline.bankaccountnumber" :placeholder="$t('getapi[1220]')"
                                                              size="mini"></el-input>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><span>{{$t('getapi[1227]')}}</span></td>
                                                <td style="width:50px">
                                                    <routejump :urlNo="24">
                                                    <el-select class="mcolor"
                                                               filterable
                                                               v-model="formInline.currency_code_id"
                                                               @change="cahngecurr"
                                                               :disabled="!CanEdit"
                                                               size="mini"
                                                               style="width: 100px"
                                                    >
                                                        <el-option v-for="(item, index) in Currency" :label="item.currency_code"
                                                                   :value="item.currency_code" :key="index"></el-option>
                                                        <span style="color: red">*</span>
                                                    </el-select>
                                                    {{$t('getapi[6456]')}}{{ formInline.currency_zh }}
                                                    </routejump>
                                                </td>
                                                <td><span>{{$t('getapi[1249]')}}</span></td>
                                                <td>
                                                    <routejump :urlNo="25">
                                                    <el-select :disabled="!CanEdit" filterable v-model="formInline.tax_rate"
                                                               @change="cahngerate" size="mini" class="mcolor"
                                                               style="width: 100px">
                                                        <el-option v-for="(item, index) in RateCode" :label="item.tax_code"
                                                                   :value="item.tax_code" :key="index"></el-option>
                                                    </el-select>
                                                    <!-- <el-input v-model="formInline.Tax_Code" placeholder="税代码" style="width:100px"></el-input> -->
                                                    {{$t('getapi[1248]')}}{{ formInline.tax_rate_name }}%
                                                    </routejump>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><span>{{$t('getapi[6457]')}}</span></td>
                                                <td><el-input
                                                        v-model="formInline.tax_part_code"
                                                        :placeholder="$t('getapi[6457]')"
                                                        type="text"
                                                        class="mcolor"
                                                        size="mini"
                                                        style="width: 200px"
                                                        readonly
                                                >
                                                    <i class="el-icon-edit el-input__icon" slot="suffix" @click="ssf"></i>
                                                </el-input></td>
                                                <td><span>{{$t('getapi[6458]')}}</span></td>
                                                <td><el-input
                                                        v-model="formInline.tax_part_name"
                                                        :placeholder="$t('getapi[6458]')"
                                                        type="text"
                                                        size="mini"
                                                        :readonly="true" class="readO"
                                                ></el-input></td>
                                                <td><span>{{$t('getapi[6450]')}}</span></td>
                                                <td><el-input
                                                        v-model="formInline.tax_discount_flag"
                                                        :placeholder="$t('getapi[6450]')"
                                                        type="text"
                                                        size="mini"
                                                        :readonly="true" class="readO"
                                                ></el-input></td>
                                            </tr>
                                           
                                        </table>
                                        <div>
                                            <el-divider  content-position="left"><span style="font-weight:bold">{{$t('getapi[6459]')}}</span></el-divider>
                                        </div>
                                        <!-- <span style="font-weight:bold">{{$t('getapi[6459]')}}</span> -->
                                        <table>
                                            <tr>
                                                <td style="width:68px"><span>{{$t('getapi[1082]')}}</span></td>
                                                <td style="width:100px">
                                                    <routejump :urlNo="23">
                                                    <el-select class="mcolor" filterable
                                                               v-model="formInline.payment_way">
                                                        <el-option v-for="(item, index) in PaymentWay"
                                                                   :label="item.Payment_Manner_Name" :value="item.num"
                                                                   :key="index"></el-option>
                                                    </el-select>
                                                    </routejump>
                                                </td>
                                                <td style="width:50px"><span>{{$t('getapi[1250]')}}</span></td>
                                                <td style="width:100px">
                                                    <el-input
                                                            class="mcolor"
                                                            v-model="formInline.checkout_cycle"
                                                            :placeholder="$t('getapi[1250]')"
                                                            type="number"
                                                            autocomplete="off" title=""
                                                            @mousewheel.native.prevent
                                                            size="mini"
                                                    ></el-input>
                                                </td>
                                                <td style="width:50px"><span>{{$t('getapi[1228]')}}</span></td>
                                                <td style="width:100px">
                                                    <el-select filterable v-model="formInline.balance_mode">
                                                        <el-option v-for="(items, index) in BalanceMode" :label="items.item"
                                                                   :value="items.value" :key="index"></el-option>
                                                    </el-select>
                                                </td>
                                                <td v-show="formInline.balance_mode == 'Month_Balance'">
                                                    <span class="el-form-item__label">{{$t('getapi[2620]')}}</span>
                                                    <el-input v-model="formInline.payment_day" placeholder="" type="number" autocomplete="off" title="" @mousewheel.native.prevent
                                                              size="mini" style="width: 100px"></el-input>
                                                    <span class="el-form-item__label">{{$t('getapi[6460]')}}</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colspan="7">
                                                    <el-radio v-model="formInline.payday_calcmode" :label="0" @change="paydaysarr=[];formInline.paydays=''">
                                                        {{$t('getapi[6461]')}}
                                                    </el-radio>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colspan="7">
                                                    <el-radio v-model="formInline.payday_calcmode" :label="1">
                                                        {{$t('getapi[6462]')}}
                                                        <el-radio v-model="formInline.payday_calcmode" :label="1"
                                                                  style="margin-left: 40px"
                                                                  :disabled="formInline.payday_calcmode == 0" @change="paydaysarr=[]">
                                                            {{$t('getapi[2620]')}}
                                                        </el-radio>
                                                        <el-radio v-model="formInline.payday_calcmode" :label="2"
                                                                  :disabled="formInline.payday_calcmode == 0" @change="paydaysarr=[]">{{$t('getapi[2619]')}}
                                                        </el-radio>
                                                        <el-input
                                                                v-model="formInline.paydays"
                                                                placeholder=""
                                                                type="text"
                                                                style="width: 120px"
                                                                size="mini"
                                                                :readonly="true" class="readO"
                                                                v-if="formInline.payday_calcmode == 0"
                                                        ></el-input>
                                                        <el-select filterable multiple class-name="check" v-model="paydaysarr" v-if="formInline.payday_calcmode == 1">
                                                            <el-option v-for="item in arrpaydaysM" :key="item.value" :title="item.value"
                                                                       :value="item.value" size="mini"></el-option>
                                                        </el-select>
                                                        <el-select filterable multiple class-name="check" v-model="paydaysarr" v-if="formInline.payday_calcmode == 2">
                                                            <el-option v-for="item in arrpaydaysW" :key="item.value" :title="item.value"
                                                                       :value="item.value" size="mini"></el-option>
                                                        </el-select>
                                                        日
                                                        <span style="color: blue">{{$t('getapi[6463]')}}</span>
                                                    </el-radio>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><span>{{$t('getapi[8234]')}}</span></td>
                                                <td style="width:100px">
                                                    <el-select filterable class-name="check" clearable v-model="formInline.Postpone_Date">
                                                        <el-option v-for="item in arrpostdate" :key="item.value" :title="item.value"
                                                                   :value="item.value" size="mini"></el-option>
                                                    </el-select>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><span>{{$t('getapi[1222]')}}</span></td>
                                                <td colspan="6">
                                                    <el-input type="textarea" v-model="formInline.payment_clause"
                                                              :placeholder="$t('getapi[1222]')" style="width:100%" size="mini"></el-input>
                                                </td>
                                            </tr>
                                        </table>
                                        <div v-if="userinfo.Login_DB!='MY'">
                                            <el-divider  content-position="left"><span style="font-weight:bold">{{$t('getapi[6464]')}}</span></el-divider>
                                        </div>
                                        <!-- <span style="font-weight:bold">{{$t('getapi[6464]')}}</span> -->
                                        <table v-if="userinfo.Login_DB!='MY'">
                                            <tr>
                                                <td style="width:80px"><span>{{$t('getapi[6446]')}}</span></td>
                                                <td style="width:250px" colspan="3">
                                                    <el-input
                                                            class="mcolor"
                                                            v-model="formInline.invoice_add"
                                                            :placeholder="$t('getapi[6446]')"
                                                            type="text"
                                                            size="mini"
                                                    ></el-input>
                                                </td>
                                                <td style="width:50px"><span>{{$t('getapi[1206]')}}</span></td>
                                                <td style="width:100px">
                                                    <el-input
                                                            class="mcolor"
                                                            v-model="formInline.invoice_zipcode"
                                                            :placeholder="$t('getapi[1206]')"
                                                            type="text"
                                                            size="mini"
                                                    ></el-input>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><span>{{$t('getapi[6447]')}}</span></td>
                                                <td style="width:100px">
                                                    <el-input
                                                            class="mcolor"
                                                            v-model="formInline.invoice_person"
                                                            :placeholder="$t('getapi[6447]')"
                                                            type="text"
                                                            style="width: 120px"
                                                            size="mini"
                                                    ></el-input>
                                                </td>
                                                <td style="width:50px"><span>{{$t('getapi[1202]')}}</span></td>
                                                <td style="width:100px">
                                                    <el-input
                                                            class="mcolor"
                                                            v-model="formInline.invoice_tel"
                                                            :placeholder="$t('getapi[1202]')"
                                                            type="text"
                                                            style="width: 120px"
                                                            size="mini"
                                                    ></el-input>
                                                </td>
                                                <td style="width:50px"><span>{{$t('getapi[12452]')}}</span></td>
                                                <td style="width:100px">
                                                    <el-input
                                                            v-model="formInline.Inv_SendDays"
                                                            :placeholder="$t('getapi[12452]')"
                                                            type="number" autocomplete="off" title="" @mousewheel.native.prevent
                                                            size="mini"
                                                    ></el-input>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><span>{{$t('getapi[12532]')}}</span></td>
                                                <td style="width:100px">
                                                    <el-input
                                                            v-model="formInline.Ven_Days"
                                                            :placeholder="$t('getapi[12532]')"
                                                            type="number" autocomplete="off" title="" @mousewheel.native.prevent
                                                            style="width: 120px"
                                                            size="mini"
                                                    ></el-input>
                                                </td>
                                                <td><span>{{$t('getapi[12659]')}}</span></td>
                                                <td>
                                                    <el-input
                                                            v-model="formInline.InvRec_Email"
                                                            :placeholder="$t('getapi[12659]')"
                                                            type="text"
                                                            size="mini"
                                                    ></el-input>
                                                </td>
                                                <td><span>{{$t('getapi[12660]')}}</span></td>
                                                <td>
                                                    <el-input
                                                            v-model="formInline.InvRec_Person"
                                                            :placeholder="$t('getapi[12660]')"
                                                            type="text"
                                                            size="mini"
                                                    ></el-input>
                                                </td>
                                            </tr>
                                        </table>
                                        <div v-if="userinfo.Login_DB!='MY'">
                                            <el-divider  content-position="left"><span style="font-weight:bold">{{$t('getapi[12790]')}}</span></el-divider>
                                        </div>
                                        <table v-if="userinfo.Login_DB!='MY'">
                                            <tr>
                                                <td style="width:80px"><span>{{$t('getapi[12786]')}}</span></td>
                                                <td style="width:200px"  >
                                                    <el-input
                                                            class="mcolor"
                                                            v-model="formInline.we_openbank_name"
                                                            :placeholder="$t('getapi[12786]')"
                                                            type="text"
                                                            size="mini"
                                                    ></el-input>
                                                </td>
                                                <td style="width:80px"><span>{{$t('getapi[12787]')}}</span></td>
                                                <td style="width:200px"  >
                                                    <el-input
                                                            class="mcolor"
                                                            v-model="formInline.we_openbank_number"
                                                            :placeholder="$t('getapi[12787]')"
                                                            type="text"
                                                            size="mini"
                                                    ></el-input>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style="width:80px"><span>{{$t('getapi[12788]')}}</span></td>
                                                <td style="width:200px"  >
                                                    <el-input
                                                            class="mcolor"
                                                            v-model="formInline.we_bankaccount"
                                                            :placeholder="$t('getapi[12788]')"
                                                            type="text"
                                                            size="mini"
                                                    ></el-input>
                                                </td>
                                                <td style="width:80px"><span>{{$t('getapi[12789]')}}</span></td>
                                                <td style="width:200px"  >
                                                    <el-input
                                                            class="mcolor"
                                                            v-model="formInline.we_acceptance_number"
                                                            :placeholder="$t('getapi[12789]')"
                                                            type="text"
                                                            size="mini"
                                                    ></el-input>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </el-tab-pane>
                                <el-tab-pane :label="$t('getapi[6465]')">
                                    <el-upload
                                            class="upload-demo"
                                            ref="upload"
                                            :action="uploadurl"
                                            :on-preview="handlePreview"
                                            :on-remove="handleRemove"
                                            :on-change="handleChange"
                                            :on-success="handleSuccess"
                                            :on-error="handleError"
                                            :before-upload="beforeAvatarUpload"
                                            :file-list="fileList3"
                                            :data="fileparm"
                                            :limit="1"
                                    >
                                        <el-button slot="trigger" size="mini" type="primary">{{$t('getapi[6422]')}}</el-button>
                                        <div slot="tip" class="el-upload__tip"></div>
                                    </el-upload>
                                    <el-table
                                            :data="FileList"
                                            v-loading="loading"
                                            :highlight-current-row="false"
                                            show-overflow-tooltip="true"
                                            border
                                            stripe
                                            size="mini"
                                            header-row-class-name="headerclass"
                                    >
                                        <el-table-column show-overflow-tooltip prop="Node_Name"
                                                         :label="$t('getapi[3590]')"></el-table-column>
                                        <el-table-column show-overflow-tooltip prop="Doc_Type"
                                                         :label="$t('getapi[6423]')"></el-table-column>
                                        <el-table-column show-overflow-tooltip prop="Doc_Size"
                                                         :label="$t('getapi[7875]')"></el-table-column>
                                        <el-table-column show-overflow-tooltip prop="Upload_Person"
                                                         :label="$t('getapi[6425]')"></el-table-column>
                                        <el-table-column show-overflow-tooltip prop="Upload_Time"
                                                         :label="$t('getapi[6426]')"></el-table-column>
                                        <el-table-column prop="operate" :label="$t('getapi[6048]')" width="100">
                                            <template slot-scope="scope">
                                                <el-button @click.native.prevent="open(scope)" type="text" size="mini">
                                                    {{ scope.row.operate }}
                                                </el-button>
                                                <el-button @click.native.prevent="filedel(scope)" type="text"
                                                           size="mini">{{ $t('getapi[40]') }}
                                                </el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </el-tab-pane>
                            </el-tabs>
                        </el-form>
                    </el-col>
                </el-row>
                <!-- 编辑弹框 -->
            </li>
        </ul>
        <!-- 分页 -->
        <el-row class="page">
            <el-col :span="16">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[50, 100, 200, 300, 400]"
                        :page-size="PageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="8">
                <div
                        style="
            text-align: right;
            line-height: 30px;
            color: #545c64;
            font-size: 95%;
          "
                >
                    {{ $t('getapi[7980]') }}:{{ DbTbNames }}
                </div>
            </el-col>
        </el-row>
        <!-- 分页 -->
        <!-- 搜索弹框 -->
        <!-- <serce :isVisible="isVisible" :queryData="SalCustomerInfoViewInfo" ref="ser" @getser="serclick"></serce> -->
        <serce :isVisible="isVisible" queryData="SalCustomerInfoViewInfo" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[996]')" queryData="SalCustomerInfoViewInfo" :tabNo="SelectIndex" ref="ctab"
                @getctab="sortclick"></ctable>
        <selector :isVisible="false" :isSplitPage="true" :postUrl="'/Sal/Cus/GetProductListPopupList'"
                  @callback="getsalss" ref="input"></selector>
       <!-- <salss :isVisible="salssvisi" ref="input" @getsalss="getsalss"></salss>-->
        <!-- 销售员 -->
        <selector :isVisible="false" :isSplitPage="true" :postUrl="'/Basic/Popup/GetEmployeeDataList'"
                  @callback="addmaterials" ref="addmaterials"></selector>
        <!-- 		<el-dialog :visible.sync="isVisible" :title="$t('getapi[3653]')" width="30%">
            <el-tabs type="border-card">
                <el-tab-pane :label="$t('getapi[2020]')">
                    <el-table :data="queryData" border height="400" size="mini" style="width: 100%;">
                        <el-table-column show-overflow-tooltip prop="Field_Show_Name" :label="$t('getapi[2021]')" width="150"></el-table-column>
                        <el-table-column show-overflow-tooltip :label="$t('getapi[2022]')">
                            <template slot-scope="scope">
                                <input type="text" v-model="scope.row.query_Condition" style="border:none" />
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
                <el-tab-pane :label="$t('getapi[2028]')"><div style="min-height: 400px; line-height: 30px;" v-html="hleptext"></div></el-tab-pane>
            </el-tabs>

            <span slot="footer" class="dialog-footer">
                <el-button @click="isVisible = false">{{ $t('getapi[6]') }}</el-button>
                <el-button type="primary" @click="intidata">{{ $t('getapi[937]') }}</el-button>
            </span>
        </el-dialog> -->
        <!-- 搜索弹框 -->
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import urlpost from '@/api/config.js';
    import { Loading } from 'element-ui';
    import { encryptDes, decryptDes,generatekey } from '@/utils/des.js'

    export default {
        name: 'salcelient',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3-Common.reduceTableHeight2,
                    maxHeight: this.$windowSize.tableHeight3-Common.reduceTableHeight2,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                tableHeader1: [],
                tableHeader2: [],
                btnlist: {
                    newblock: false,
                    searchblock: false,
                    delblock: false,
                    reflashblock: false,
                    printblock: false,
                    impblock: false,
                    expsblock: false
                }, //按钮权限
                fileList3: [],
                FileList: [],
                CoList:[],
                editaddress: '', // 用于编辑-订单相关中的交货地址
                rowindex: '', // 订单相关 选中行
                formInline: {},
                oldFormInline: '',
                ids: '',
                showloading: '',
                isVisible: false,
                DbTbNames: '', //表名
                datajson: [],
                PageIndex: 1,
                PageSize: this.$http.getPageSize('salcelient'),
                SelectIndex: 0,
                oldSelectIndex: 0,
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                reduceTableHeight: Common.reduceTableHeight2,
                isShowEdit: false, // 是否显示编辑页面
                dataSetDetail: {}, // 编辑页面数据详情
                queryData: [], // 查询数组
                selectIDData: '', // 选择的数据的ID集合
                tracetype: 0, //跟踪类别
                url: '', // 零件图路径
                isEdit: true, // 是否新增
                CanEdit: false,//能否编辑，作用与字段
                CustomerTypeList: [], //客户类型
                CustomerGroupList: [], //客户性质
                VenderGrade: [], //等级
                VenderImportant: [], //重要度
                Country: [], //国家
                AreaS: [], //地区
                TransMode: [], //运输方式
                Currency: [], //货币代码
                RateCode: [], //税代码
                DeliveryTerm: [], //交付条款
                BalanceMode: [
                    {
                        item: '票到',
                        value: 'Invoice_Arrive'
                    },
                    {
                        item: '月结',
                        value: 'Month_Balance'
                    },
                    {
                        item: '预付款',
                        value: 'Advance_Payment'
                    },
                    {
                        item: '款到发货',
                        value: 'Sum_Send'
                    }
                ], //开票单位
                invoicecompany: [
                    {
                        code: '美宇',
                        name: '美宇'
                    },
                    {
                        code: '锐拓',
                        name: '锐拓'
                    }
                ], //结算方式
                PaymentWay: [], //付款方式
                SalTypeList: [], //销售类别
                DeliveryTermList: [], //交货条款
                mposdis:false,
                flashow:true,
                currentRow: null,
                uploadurl: '', //上传文件访问路径
                fileparm: {
                    Code: '',
                    Doc_Detail: '',
                    Data_Type: 6,
                    flag: 1,
                    Type: 5, // 客户信息
                    Login_Group:'', 
                    Login_DB:'',
                },
                exclusively_id: 0,
                activeName: 0,
                oldrow: '',
                iscontinuedblclick: true,
                timeId: null,
                code: '',
                selectDataColist: [], //订单相关 - 行多选
                arrpaydaysM:[
                    {value:1},{value:2},{value:3},{value:4},{value:5},{value:6},{value:7},{value:8},{value:9},{value:10},
                    {value:11},{value:12},{value:13},{value:14},{value:15},{value:16},{value:17},{value:18},{value:19},{value:20},
                    {value:21},{value:22},{value:23},{value:24},{value:25},{value:26},{value:27},{value:28},{value:29},{value:30},
                    {value:31},{value:'最后一天'}
                ],
                arrpaydaysW:[
                    {value:'周一'},{value:'周二'},{value:'周三'},{value:'周四'},{value:'周五'},
                ],
                arrpostdate:[
                    {value:'周一'},{value:'工作日'},
                ],
                paydaysarr: [],
                scrollTop:0,
                scrollTop1:0,
                scrollTop2:0,
                scrollTop3:0,
                userinfo: {},
            };
        },
        create() {
            this.getselect();
        },
        beforeMount() {
            console.log('beforeMount');
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            let token = JSON.parse(that.userData).token;
            that.uploadurl = Common.FileUrl + 'Files/UpFileByDocManage?token=' + token;
            const key = generatekey(8); // 也可直接指定key let key = 'des';
            that.fileparm.Login_Group=encryptDes(JSON.parse(that.userData).Login_Group,key);
            that.fileparm.Login_DB=encryptDes(JSON.parse(that.userData).Login_DB,key);
            that.getselect();
        },
        watch: {
            datajson: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(that.SelectIndex)
                })
            },
        },
        mounted() {
            // console.log('mounted');
            let that = this;
            that.userinfo = JSON.parse(sessionStorage.getItem('userData'));
            that.colsort();
            that.$processdata.pushModelCache('salcelient', that)
            that.$limits.dragControllerDiv();
            //that.intidata();
            that.oldFormInline = JSON.stringify(that.formInline)
            that.confirmAdd(); 
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.singleTable1.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
                that.$refs.singleTable2.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop2 = res.target.scrollTop
                },false)
                that.$refs.singleTable3.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop3 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.singleTable1.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop1;
                    this.$refs.singleTable2.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop2;
                    this.$refs.singleTable3.bodyWrapper.scrollTop =this.scrollTop3;
                }, 13)
            })
        },
        methods: {
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('SalCustomerInfoViewInfo', that.SelectIndex, PFileds => {
                    if(that.SelectIndex==0){
                        that.tableHeader=PFileds;
                    }
                    else if(that.SelectIndex==1){
                        that.tableHeader1=PFileds;
                    }
                    else if(that.SelectIndex==2){
                        that.tableHeader2=PFileds;
                    }
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[996]"),this.$t("getapi[14]"));
            },
            //按钮操作权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                if (!this.$limits.menuvisible("plv2", 99, 1)) {
                    var value = that.$limits.newOperationAuthorityView('plv2', 98, 1, that.total);
                    that.$refs.SetBtn.SetButtonEnable(value);
                } else {
                    if (that.$limits.ReadOnlyRightsView('plv2', 99, 1)) {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    //操作权
                    console.log('权限' + that.$limits.OperationAuthority('plv2', 99, 1, that.exclusively_id))
                    let ilimits = that.$limits.OperationAuthority('plv2', 99, 1, that.exclusively_id);
                    // limits说明：、1 查询级、2 编辑权限、3 删除权限
                    switch (ilimits) {
                        case -1:
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                            break;
                        case 1:
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                            break;
                        case -2:
                            that.$refs.SetBtn.SetButtonEnable('search,create,save,refresh,export');
                            break;
                        case 2:
                            that.$refs.SetBtn.SetButtonEnable('search,create,save,refresh,export');
                            break;
                        case -3:
                            that.$refs.SetBtn.SetButtonEnable('search,create,save,refresh,export');
                            break;
                        case 3:
                            if(that.formInline.status == 0){
                                that.$refs.SetBtn.SetButtonEnable('search,create,save,del,refresh,export');
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('search,create,save,refresh,export');
                            }
                            break;
                        default:
                            break;
                    }
                }
            },
            tableRowClassName({row, rowIndex}) {
                row.index = rowIndex;
            },
            //客户编码输入
            cusinput(e) {
                this.fileparm.Code = e;
            },
            //字符转数字
            // PageIndex()
            //获取查询条件
            serclick(val) {
                // console.log(val);
                this.queryData = val;
                this.intidata();
            },
            //修改页数
            handleSizeChange(val) {
                this.PageSize = val;
                this.$http.savePageSize('salcelient',val)
                this.intidata();
                this.authority();
            },
            //跳页
            handleCurrentChange(val) {
                this.PageIndex = val;
                this.intidata();
                this.authority();
            },
            //编辑
            editInfo(row) {
                let that = this;
                that.authority();
            },
            // 获取数据
            intidata() {
                let that = this;
                that.loading = true;
                let pm = {
                    query_Condition: '',
                    query_field_type: '',
                    query_field_name: '',
                    row_sign: '',
                    query_sort: ''
                };
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Param: []
                };
                that.queryData.forEach(item => {
                    //				if(item.query_Condition==''||item.query_Condition.length>0) {
                    pm = {
                        row_sign: item.row_sign,
                        query_Condition: item.query_Condition,
                        query_sort: item.query_sort,
                        query_field_type: item.Query_Field_Type,
                        query_field_name: item.Query_Field_Name
                    };
                    parm.Param.push(pm);
                    //				}
                });
                // console.log(parm);
                that.$http.urlpost('/Sal/Cus/DataList', parm, function (res) {
                    // console.log(res);
                    if (res.Success == 1) {
                        that.datajson = res.DataContent;
                        that.total = res.Totals;
                        that.DbTbNames = res.DbTbNames;
                    }
                    that.loading = false;
                });
            },
            // 保存数据
            save() {
                let that = this;
                if(that.formInline.payday_calcmode == 1 || that.formInline.payday_calcmode == 2){
                    let str = ''
                    for(let i = 0;i<that.paydaysarr.length;i++){
                        str = str + that.paydaysarr[i] + ','
                    }
                    that.formInline.paydays = str.substring(0,str.length-1)
                }
                let parm = that.formInline;
                parm.ls = that.CoList
                that.$refs.SetBtn.SetOneBtnEnable('save', false);
                that.loading = true;
                let parms = JSON.stringify(parm);
                // console.log(parms);
                var reg = new RegExp('null', 'g'); //创建正则baiRegExp对象
                parms = parms.replace(reg, '""');
                console.log(parms);
                that.$http.urlpost('/Sal/Cus/SaveData', JSON.parse(parms), function (res) {
                    console.log(res);
                    if (res.Success == 1) {
                        that.$message.success(that.$t('getapi[284]'));
                        that.intidata();
                        let pms = that.formInline;
                        pms.Exclusively_Id = res.UniqueNum;
                        that.getdetail(pms);
            /*            let result = that.datajson.findIndex(item => item.Exclusively_Id == res.UniqueNum);
                        if (result >= 0) {
                            let fsd = document.getElementsByClassName('fsd');
                            fsd[result].focus();
                        }*/
                        that.loading = false;
                    }
                    that.loading = false;

                });
                that.$refs.SetBtn.SetOneBtnEnable('save', true);
            },
            // 编辑
            edit(jsd) {
                this.formInline = jsd.row;
                this.isEdit = true;
                this.getdetail(jsd.row);
                this.authority();
            },
            edits(row) {
                let that = this
                if(that.code == row.Exclusively_Id){
                    return
                }
                that.timeId = setTimeout(() => {
                    if (!this.$limits.menuvisible("plv2", 99, 1)) {
                        return
                    }
                    if (that.oldFormInline != JSON.stringify(that.formInline)) {
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.oldSelectIndex = that.activeName
                                that.iscontinuedblclick = true
                                that.code = row.Exclusively_Id
                                that.oldrow = row
                                this.isEdit = true;
                                this.getdetail(row);
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                if (that.oldSelectIndex == 0) {
                                    that.$refs.singleTable.$refs.singleTable.setCurrentRow(that.oldrow);
                                } else if (that.oldSelectIndex == 1) {
                                    that.$refs.singleTable1.$refs.singleTable.setCurrentRow(that.oldrow);
                                } else if (that.oldSelectIndex == 2) {
                                    that.$refs.singleTable2.$refs.singleTable.setCurrentRow(that.oldrow);
                                }
                                that.activeName = that.oldSelectIndex
                            });
                    } else {
                        that.oldSelectIndex = that.activeName
                        that.iscontinuedblclick = true
                        that.code = row.Exclusively_Id
                        that.oldrow = row
                        this.isEdit = true;
                        this.getdetail(row);
                        this.authority();
                    }
                }, 100);
            },
            selectInfo(tab, event) {
                let that = this;
                that.SelectIndex = tab.name;
                that.activeName = tab.name;
                that.colsort();
                that.$nextTick(function(){
                    that.$processdata.initForm(that.SelectIndex)
                });
            },
            handleSelectionChange(val) {
                let that = this;
                that.selectIDData = '';
                for (let i = 0; i < val.length; i++) {
                    that.selectIDData += val[i].Exclusively_Id + ',';
                }
                // console.log(that.selectIDData);
            },
            // 删除
            delf() {
                let that = this;
                console.log(that.ids);
                let parm = {
                    exclusively_id: that.ids.exclusively_id,
                    update_time: that.ids.update_time
                };
                that.$http.urlpost('Sal/Cus/DeleteCusInfo', parm, res => {
                    console.log(res);
                    if (res.Success == 1) {
                        that.$message.success(that.$t('getapi[659]'));
                        that.datajson.forEach(function (item, index) {
                            if (that.ids.Exclusively_Id == item.Exclusively_Id) {
                                that.datajson.splice(index, 1);
                                that.getdetail(that.datajson[index - 1]);
                                let fsd = document.getElementsByClassName('fsd');
                                fsd[index - 1].focus();
                            }
                        });
                    }
                });
            },
            // 删除
            del(jsd) {
                let that = this;
                this.ids = jsd.row.Exclusively_Id;
                that.$confirm(that.$t('getapi[8594]'), that.$t('getapi[194]'), {//'此操作将永久删除该数据, 是否继续?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        that.delf();
                    })
                    .catch(() => {
                    });
            },
            //批量删除
            delall() {
                let that = this;
                that.ids = this.formInline;
                that.$confirm(that.$t('getapi[8594]'), that.$t('getapi[194]'), {//'此操作将永久删除该数据, 是否继续?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        that.delf();
                    })
                    .catch(() => {
                    });
            },
            // 新增
            add() {
                let that = this;
                console.log(that.oldFormInline)
                console.log(JSON.stringify(that.formInline))
                if (that.oldFormInline != JSON.stringify(that.formInline)) {
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.openEdit()
                            that.confirmAdd()
                        });
                } else {
                    that.openEdit()
                    that.confirmAdd()
                }
            },
            confirmAdd() {
                let that = this;
                that.code = ''
                that.formInline = {
                    exclusively_id: null,
                    customer_id: '',
                    customer_name: '',
                    shortname: '',
                    customer_type_id: '',
                    customers_group: '',
                    customer_important: '',
                    customer_developer: '',
                    country: '',
                    district: '',
                    customer_address: '',
                    legalperson: '',
                    contact_telephone: '',
                    fax: '',
                    contact_person: '',
                    contact_post: '',
                    post_code: '',
                    mail_address: '',
                    phase_in_date: '',
                    phase_out_date: '',
                    status: 0,
                    aremarks: '',
                    create_person: '',
                    create_time: '',
                    update_person: '',
                    update_time: '',
                    isdelete: '',
                    issealed: 0,
                    delivery_term: '',
                    delivery_address: '',
                    delivery_contract: '',
                    delivery_phone: '',
                    transport_type: '',
                    delivery_leadtime: 0,
                    bremarks: '',
                    sal_empname: '',
                    bankaccount_name: '',
                    bankaccountnumber: '',
                    checkout_cycle: 0,
                    payment_way: '',
                    payment_clause: '',
                    tax_id: '',
                    tax_rate: '',
                    financing_type: '',
                    currency_code_id: '',
                    invoice_add: '',
                    invoice_title: '',
                    invoice_person: '',
                    invoice_tel: '',
                    invoice_zipcode: '',
                    balance_mode: '',
                    payday_calcmode: 0,
                    paydays: '',
                    payment_day: 0,
                    consignment_flag: 0,
                    consignment_pos: '',
                    sale_issue_type: 1,
                    direct_move_flag: 0,
                    moving_pos: '',
                    issue_part_flow: 0,
                    tax_part_code: '',
                    tax_part_name: '',
                    tax_discount_flag: '',
                    invoice_addr2: '',
                    invoice_tel2: '',
                    ls: [],
                    price_type: 0,
                    Inv_SendDays: 0,
                    Ven_Days:0,
                    we_openbank_name:'',
                    we_openbank_number:'',
                    we_bankaccount:'',
                    we_acceptance_number:'',
                    mode:0,
                    iskpirate:0,
                    invoice_companyname:'',
                    report_need:0,
                }
                that.paydaysarr = []
                this.CoList = [];
                this.fileList3 = [];
                this.FileList = [];
                this.isEdit = false;
                this.CanEdit = true;
                that.oldFormInline = JSON.stringify(that.formInline)
                this.authority();
            },
            //删除文件
            filedel(row) {
                let that = this;
                let index = row.$index;
                that.ids = this.selectIDData;
                that.$confirm(that.$t('getapi[8599]'), that.$t('getapi[194]'), {//此操作将永久删除该文件, 是否继续?
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            ids: row.row.Node_ID,
                            FilesSrc: row.row.FileSrc
                        };
                        that.$http.urlpost('/Basic/DeleteFileByDocManageID', parm, res => {
                            if (res.Success == 1) {
                                that.$message.success(that.$t('getapi[659]'));//'删除成功'
                                that.FileList.splice(index, 1);
                            }
                        });
                    })
                    .catch(() => {
                    });
            },
            //打开文件
            open(row) {
                 let that = this;
                const key = generatekey(8); // 也可直接指定key let key = 'des';
                that.loading = true;
                that.userData = sessionStorage.getItem('userData');
                let parm = {
                    Login_Group: encryptDes(JSON.parse(that.userData).Login_Group,key),
                    Login_DB: encryptDes(JSON.parse(that.userData).Login_DB,key),
                    CType:row.row.ConfigType,
                    OthInfo:'',
                    NodeId:row.row.Node_ID,
                };
                console.log(parm);
                that.$http.urlfilepost(row.row.HttpPost,'/Files/GetFileUrl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl =res.DataContent;
                        window.open(hrefurl);
                    }
                    that.loading = false;
                });                
            },
            //打开税收商品弹框
            ssf() {
                this.$refs.input.clearInput(true);
            },
            //获取物料信息
            getsalss(val) {
                console.log(val);
                let ff = val.tax_part_code;
                let ff1 = val.tax_part_name;
                let ff2 = val.tax_discount_flag;
                let fors = this.formInline;
                this.$set(this.formInline, 'tax_part_code', ff);
                this.$set(this.formInline, 'tax_part_name', ff1);
                this.$set(this.formInline, 'tax_discount_flag', ff2);
            },
            // 查询
            search() {
                this.isVisible = true;
                this.$refs.ser.clearInput(this.isVisible, 'SalCustomerInfoViewInfo');
            },
            // 刷新
            reflash() {
                /*this.intidata();
                this.getdetail(this.formInline);*/
                let that = this;
                if (that.oldFormInline != JSON.stringify(that.formInline)) {
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            this.intidata();
                            let item = {
                                Exclusively_Id: that.formInline.exclusively_id,
                                Customer_Name: that.formInline.customer_name,
                            }
                            this.getdetail(item);
                        });
                } else {
                    this.intidata();
                    let item = {
                        Exclusively_Id: that.formInline.exclusively_id,
                        Customer_Name: that.formInline.customer_name,
                    }
                    this.getdetail(item);
                }
            },
            //导出·
            exp() {
                let that = this;
                that.loading = true;
                let pm = {
                    query_Condition: '',
                    query_field_type: '',
                    query_field_name: '',
                    row_sign: '',
                    query_sort: ''
                };
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Param: []
                };
                that.queryData.forEach(item => {
                    //				if(item.query_Condition==''||item.query_Condition.length>0) {
                    pm = {
                        row_sign: item.row_sign,
                        query_Condition: item.query_Condition,
                        query_sort: item.query_sort,
                        query_field_type: item.Query_Field_Type,
                        query_field_name: item.Query_Field_Name
                    };
                    parm.Param.push(pm);
                    //				}
                });
                console.log(parm);
                that.$http.urlpost('/Sal/Cus/ExportToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                    that.loading = false;
                });
            },
            //操作按钮
            stat(e) {
                // console.log(e);
                let parm = {
                    IID: '',
                    Code: typeof this.formInline.customer_id == 'undefined' ? '' : this.formInline.customer_id,
                    Name: typeof this.formInline.customer_name == 'undefined' ? '' : this.formInline.customer_name
                };
                let that = this;
                let sta = '合格客户';
                if (e == 0) {
                    sta = '合格客户';
                    parm.Status = sta;
                }
                if (e == 1) {
                    sta = '被撤销';
                    parm.Status = sta;
                    that.$http.urlpost('UpdateQuoEnable', parm, function (res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$t('getapi[8785]'));//'设置价表无效成功'
                            that.intidata();
                            that.getdetail(that.formInline);
                        }
                    });
                }
                if (e == 2) {
                    sta = '待审核';
                    parm.Status = sta;
                }
                // console.log(parm);
                if (e < 3) {
                    that.$http.urlpost('VenderInfoStatus', parm, function (res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$t('getapi[8786]'));//'改变客户状态成功'
                            that.intidata();
                            that.getdetail(that.formInline);
                        }
                    });
                } else {
                    that.$http.urlpost('UpdateLimitAmount', parm, function (res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$t('getapi[1406]'));//'解除成功'
                            that.intidata();
                            that.getdetail(that.formInline);
                        }
                    });
                }
            },
            //税率
            cahngerate(itm) {
                this.RateCode.forEach(item => {
                    if (item.tax_code == itm) {
                        this.formInline.tax_rate = item.tax_code;
                        this.formInline.tax_rate_name = item.tax_rate;

                    }
                });
            },
            //货币代码
            cahngecurr(itm) {
                this.Currency.forEach(item => {
                    if (item.currency_code == itm) {
                        this.formInline.currency_zh = item.currency_sign;
                    }
                });
            },
            // 获取详情
            getdetail(item) {
                if (item.Exclusively_Id == undefined || item.Exclusively_Id == '' || item.Exclusively_Id == null) {
                    return;
                }
                let that = this;
                that.CanEdit = false;
                let parm = {
                    Id: item.Exclusively_Id,
                    Code: '',
                    Name: item.Customer_Name,
                    Where: ''
                };
                that.exclusively_id = item.Exclusively_Id;
                that.FileList = [];
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('/Sal/Cus/GetSalCusInfoByID', parm, function (res) {
                    if (res.Success == 1) {
                        let hear = res.DataContent.Header[0];
                        that.formInline = hear;
                        if(res.DataContent.FileList){
                            that.FileList = res.DataContent.FileList
                        }
                        if(res.DataContent.CoList){
                            that.CoList = res.DataContent.CoList
                        }
                        if(that.formInline.payday_calcmode == 1 || that.formInline.payday_calcmode == 2){
                            if(that.formInline.paydays.length > 0){
                                that.paydaysarr = that.formInline.paydays.split(',')
                            }
                        } else {
                            that.paydaysarr = []
                        }
                        that.oldFormInline = JSON.stringify(hear)
                        that.authority();
                    }
                    loadingInstance.close()
                });
            },
            currency(value, currency, decimals) {
                const digitsRE = /(\d{3})(?=\d)/g;
                value = parseFloat(value);
                if (!isFinite(value) || (!value && value !== 0)) return '';
                currency = currency != null ? currency : '$';
                decimals = decimals != null ? decimals : 2;
                var ified = Math.abs(value).toFixed(decimals);
                var _int = decimals ? ified.slice(0, -1 - decimals) : ified;
                var i = _int.length % 3;
                var head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? ',' : '') : '';
                var _float = decimals ? ified.slice(-1 - decimals) : '';
                var sign = value < 0 ? '-' : '';
                return sign + currency + head + _int.slice(i).replace(digitsRE, '$1,') + _float;
            },
            //获取下拉数据
            getselect() {
                let that = this;
                let parm = {};
                // 客户类型
                that.$http.urlpost('/Basic/Sale/GetCustomerTypeList', parm, function (res) {
                    if (res.Success == 1) {
                        that.CustomerTypeList = res.DataContent;
                    }
                });
                /* 客户分组*/
                that.$http.urlpost('/Basic/Sale/GetCustomerGroupList', parm, function (res) {
                    if (res.Success == 1) {
                        that.CustomerGroupList = res.DataContent;
                    }
                });

                // 重要度
                that.$http.urlpost('VenderImportantSource', parm, function (res) {
                    if (res.Success == 1) {
                        that.VenderImportant = res.DataContent;
                    }
                });
                // 国家
                that.$http.urlpost('CountrySource', parm, function (res) {
                    if (res.Success == 1) {
                        that.Country = res.DataContent;
                    }
                });
                // 地区
                that.$http.urlpost('AreaSource', parm, function (res) {
                    if (res.Success == 1) {
                        that.AreaS = res.DataContent;
                    }
                });
                //运输方式
                that.$http.urlpost('/Basic/Sale/GetTransportTypeList', parm, function (res) {
                    if (res.Success == 1) {
                        that.TransMode = res.DataContent;
                    }
                });
                // 货币代码
                that.$http.urlpost('CurrencySource', parm, function (res) {
                    if (res.Success == 1) {
                        that.Currency = res.DataContent;
                    }
                });
                // 付款方式
                that.$http.urlpost('PaymentWaySource', parm, function (res) {
                    if (res.Success == 1) {
                        that.PaymentWay = res.DataContent;
                    }
                });

                // 税代码
                that.$http.urlpost('RateCodeSource', parm, function (res) {
                    // console.log(res);
                    if (res.Success == 1) {
                        that.RateCode = res.DataContent;
                    }
                });
                // 交付条款
                that.$http.urlpost('DeliveryTermSource', parm, function (res) {
                    if (res.Success == 1) {
                        that.DeliveryTerm = res.DataContent;
                    }
                });
                // 销售类别
                that.$http.urlpost('/Basic/Sale/GetSalTypeList', parm, function (res) {
                    if (res.Success == 1) {
                        that.SalTypeList = res.DataContent;
                    }
                });
                // 交货条款
                that.$http.urlpost('/Basic/Sale/GetDeliveryTermList', parm, function (res) {
                    if (res.Success == 1) {
                        that.DeliveryTermList = res.DataContent;
                    }
                });
            },
            handleChange(file, fileList) {
                let that = this;
                console.log('------handleChange---', file);
                if (file.response) {
                    let response = file.response.Success;
                    if (response == 0) {
                        that.$message.error(file.response.Msg);
                    } else {
                        //
                        // that.datajson = file.response.DataContent;
                    }
                }
            },
            handleSuccess(res, file, fileList) {
                let that = this;
                console.log('------handleSuccess---', res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                } else {
                    if(that.formInline.exclusively_id){
                        let item = {
                            Exclusively_Id: that.formInline.exclusively_id,
                            Customer_Name: that.formInline.customer_name,
                        }
                        that.getdetail(item);
                    }
                    that.$refs.upload.clearFiles();
                    // 后台没有返回数据
                    //that.FileList = res.DataContent.FileList;
                    // that.FileList.push({Node_Name:'',Doc_Type:'',Doc_Size:'',Upload_Person,'',Upload_Time''})
                    //that.datajson = res.DataContent;
                }
            },
            handleError(err, file, fileList) {
                let that = this;
                that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                let that = this;
                that.fileparm.Code = that.formInline.customer_id;
                console.log('---handlePreview--', that.fileparm);
                console.log(file);
            },
            beforeAvatarUpload(file) {
                let that = this;
                that.fileparm.Code = that.formInline.customer_id
                if (that.formInline.customer_id == '' || that.formInline.customer_id == null) {
                    that.$message.error(that.$t('getapi[8787]'));//'必须填写客户代码后才能上传文件'
                    return false;
                }
                console.log('---beforeAvatarUpload--', that.fileparm);
                console.log(file);

                return true;
            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if(!that.iscontinuedblclick){
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            show(ev, row) {
                let that = this;
                that.edit(row);
            },
            shows(ev, index) {
                let that = this;
                if (ev.keyCode == 38) {
                    let tds = this.datajson[index - 1];
                    this.setCurrent(tds);
                }
                if (ev.keyCode == 40) {
                    let tds = this.datajson[index + 1];
                    this.setCurrent(tds);
                }
            },
            setCurrent(row) {
                this.$refs.singleTable.setCurrentRow(row);
            },
            handleCurrentChanges(val) {
                if (val != null) {
                    let result = this.datajson.findIndex(item => item.Exclusively_Id == val.Exclusively_Id);
                    this.indf = result;
                    let fsd = document.getElementsByClassName('fsd');
                    fsd[result].focus();
                    this.currentRow = val;
                }
            },
            empnames(row) {
                this.rowindex = row.$index
                this.$refs.addmaterials.clearInputFromFunc(true, false, 5);
            },
            // 获取销售员信息
            addmaterials(e) {
                console.log(e);
                this.CoList[this.rowindex].SAL_EmpName = e.name;
            },
            // 修改类型
            changeConsignmentFlag(val){
                let that = this
                  if(val == 0){
                      that.mposdis = false;
                      that.flashow = true
                  } else {
                      that.mposdis = true;
                      that.flashow = false;
                  }
            },
            /*changeIssuePartFlow(val){
                let that = this
                if (val == 1) {
                    this.flashow = false;
                } else {
                    that.formInline.consignment_pos = ''
                    that.formInline.moving_pos = ''
                    that.formInline.direct_move_flag = 0
                    this.flashow = true;
                }
            },*/
            // 选择订单相关行
            selectColist(row){
                let that = this
                that.rowindex = row.index
                that.editaddress = row.Delivery_Address
            },
            editAddress(){
                let that = this
                that.CoList[that.rowindex]. Delivery_Address = that.editaddress
            },
            // 订单相关行 多选
            handleSelectionChangeColist(val){
                let that = this
                that.selectDataColist = val
                console.log(val)
            },
            addline(){
                let that = this
                that.CoList = [...that.CoList,{
                    exclusively_id:'',
                    Delivery_Term:'',
                    delivery_term_name:'',
                    Delivery_Address:'',
                    Delivery_Contract:'',
                    Delivery_Phone:'',
                    Transport_Type:'',
                    transport_type_name:'',
                    Delivery_Leadtime:'',
                    SAL_EmpName:'',
                    Remark:"",
                    Address_ShortName:''
                }]
            },
            batchDel(){
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            update_time: that.formInline.update_time,
                            ls:[]
                        };
                        for (let i = that.selectDataColist.length - 1; i >= 0; i--) {
                            that.CoList.splice(that.selectDataColist[i].index, 1);
                            if(that.selectDataColist[i].exclusively_id!=""){
                                let datatmp = {
                                    exclusively_id:that.selectDataColist[i].exclusively_id,
                                }
                                parm.ls.push(datatmp);
                            }
                        }
                        if(parm.ls.length>0){
                            that.$http.urlpost('/Sal/Cus/DeleteSALCustomerInfoCO', parm, function (res) {
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                    if (that.formInline.exclusively_id != '') {
                                        that.getdetail(that.formInline.exclusively_id);
                                    }
                                }
                            });
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            checkDataChange() {
                let that = this
                //如果无保存权限，直接关闭
                if(that.$limits.authority('plv2', 99,1) < 2){
                    return false
                }
                let flag = that.oldFormInline != JSON.stringify(that.formInline)
                return flag
            }
        }
    };
</script>

<style lang="scss" scoped>
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
    span.title {
        width: 100%;
        display: flex;
        height: 40px;
        line-height: 40px;
    }

    span.title .el-switch {
        display: inline-block;
        margin: 8px 30px;
    }

    .box {
        width: 100%;
        .bbl {
            margin: 0px auto 10px;
            white-space: pre;
            span {
                margin-left: 20px;
                min-width: 70px;
                text-align: left;
                line-height: 20px;
                display: inline-block;
                margin-right: 5px;
            }
        }
    }
</style>
